import MaterialTable, { MTableToolbar } from '@material-table/core';
import { Alert, AlertTitle } from '@mui/material';
import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { getToken, simpleFetch } from '../../utils/helpsers';
import { useAuth0 } from "@auth0/auth0-react";
import AddIcon from '@mui/icons-material/Add';
import Button from "@mui/material/Button";
import Collapse from "@mui/material/Collapse";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import LicensesSelector from "../../components/atoms/LicensesSelector/LicensesSelector";
import Box from "@mui/material/Box";
import {AddButtonStyles} from "./Cruds.styles";

const randomTempPassword = (length) => {
  const randomNumber = Math.floor((Math.random() * (20-10))+10)
  const password = Array(length - randomNumber.toString().length).fill().map(_ => String.fromCharCode(33 + Math.random() * (127 - 33))).join('') + randomNumber;
  if(!password.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/g)) return randomTempPassword(length);
  return password
}

const StyledTable = styled(MTableToolbar)(({ theme }) => ({
 '& .MuiFormControl-root': {
  position: "absolute",
  left: "79%"
 }
}));

const UsersByAccount = ({ groupID, groupName }) => {
  const [groups, setGroups] = useState([]);
  const [licensesByGroup, setLicensesByGroup] = useState([]);
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [authToken, setAuthToken] = useState([]);
  const [authData, setAuthData] = useState([]);
  const { user } = useAuth0();
  const userRole = user[`${process.env.REACT_APP_AUTH0_KEY}/role`]

  const [usersByGroup, setUsersByGroup] = useState();
  const [passwordReset, setPasswordReset] = useState([]);

  let columns = [];

  useEffect(() => {
    if (authToken.length >= 1) {
      axios.get('https://' + process.env.REACT_APP_AUTH0_DOMAIN + `/api/v2/users?per_page=1&include_totals=true&q=identities.connection%3A%22${process.env.REACT_APP_AUTH0_CONNECTION}%22&fields=email,phone_verified,created_at,updated_at,last_login,logins_count&search_engine=v3`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          const authResults = res['data']['total'];
          if (authResults) {
            const pages = Math.floor(parseInt(authResults) / 100);
            let usersPerPage = [];
            // Adding all fetches required based on the total of users divided into pages.
            for (let page_idx = 0; page_idx <= pages; page_idx++) {
              usersPerPage.push(axios.get('https://' + process.env.REACT_APP_AUTH0_DOMAIN + `/api/v2/users?page=${page_idx}&per_page=100&include_totals=true&q=identities.connection%3A%22${process.env.REACT_APP_AUTH0_CONNECTION}%22&fields=email,phone_verified,created_at,updated_at,last_login,logins_count&search_engine=v3`,
                  {
                    headers: {
                      'Authorization': `Bearer ${authToken}`,
                      'Content-Type': 'application/json'
                    }
                  }));
            }
            // For each page fetched merge the results in a single array and set the hook.
            Promise.all(usersPerPage).then( pages => {
              let authUsers =[];
              for (let page_idx = 0; page_idx < pages.length; page_idx++) {
                let usersData = pages[page_idx]['data']['users']
                authUsers = [...authUsers, ...usersData]
                if((page_idx + 1) === pages.length) {
                  setAuthData(authUsers)
                }
              }
            })
          }
        });
    }
  }, [authToken]);

  const allowedDomain = (rowData) => {
    let groupRow = groups.find((element, index) => {
      let valid = false;

      if (element.id === parseInt(rowData.group_id)) {
        valid = true;
      }

      return valid;
    });

    let userHasAccess = false;

    if (groupRow) {
      const whitelist = groupRow.allowed_domains ? groupRow.allowed_domains.replaceAll(' ', '').split(',') : []; //authorized domains
      if (whitelist.length >= 1) {
        userHasAccess = whitelist.some(
          function (domain) {
            let isValid = false;
            if (rowData.email) {
              const emailSplit = rowData.email.split('@');
              isValid = emailSplit[emailSplit.length - 1].toLowerCase() === domain;
            }
            return isValid;
          });
      } else {
        userHasAccess = true;
      }
    }
    return userHasAccess;
  }

  const handlePasswordRequest = (email) => {
    let resetPassword = {
      client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
      email: email,
      connection: process.env.REACT_APP_AUTH0_CONNECTION
    };

    axios.post(
      "https://" +
      process.env.REACT_APP_AUTH0_DOMAIN +
      "/dbconnections/change_password",
      resetPassword,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    setPasswordReset((emailList) => [...emailList, email]);
  };

  columns = [
    {
      title: 'Name', field: 'name', validate: rowData => {
        if (!rowData.name) {
          return 'Name cannot be blank';
        } else if((/^(\s)/g).test(rowData.name) || (/(\s)$/g).test(rowData.name)){
          return 'The name can not start or end with a white space'
        } else if((/[^\s]*\s{2,}/g).test(rowData.name)){
          return 'Do not group multiple white spaces'
        } else if (rowData.name.length < 3) {
          return 'Name must have at least three letters';
        }
        return true;
      },
    },
    { 
      title: 'Email', field: 'email', 
      validate: rowData => {
        const emailRegex = /^([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"(\[\]!#-[^-~ \t]|(\\[\t -~]))+")@([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|\[[\t -Z^-~]*])$/;     
          if (!rowData.email) {
          return 'Email is required.';
        } else if (!emailRegex.test(rowData.email)) {
          return 'Email is not valid.';
        } else if (!allowedDomain(rowData)) {
          return 'Email domain doesn\'t belong to the allowed domains.';
        } 
      }
    },
    {
      title: 'Role', field: 'role',
      validate: rowData => {
        return !!rowData.role;
      },
      lookup: {
        api_super_admin: 'Super Admin',
        api_group_admin: 'Account Admin',
        api_user: 'User',
      }
    },
    {
      title: 'Account', field: 'group_id',
      initialEditValue: groupID,
      render: props => groupName,
      editComponent: props => groupName
    },
    {
      title: 'License', field: 'license_id',
      render: rowData => rowData.license_id ? rowData.license_type : 'No License',
      editComponent: props => {
        return (
            <LicensesSelector
                licenses={licensesByGroup}
                licenseId={props.value}
                licenseType={props.rowData.license_type}
                onChange={e => {
                  // The licenseId object (value/label) is required to update user licenseType data on Oauth.
                  if (e) return props.onChange(e)
                }}
            />
        );
      }
    },
    //{ title: 'Dev Enabled', field: 'dev_enabled' },
    {
      title: 'Reset Password',
      render: rowData => {
        return (
            <>
              <Button variant="outlined" onClick={() => handlePasswordRequest(rowData.email)}>
                Request New Password
              </Button>
              <Collapse in={passwordReset.includes(rowData.email)}>
                <Alert
                    action={
                      <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setPasswordReset((emailList) => emailList.filter(email => email !== rowData.email));
                          }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{ mb: 2 }}
                >
                  Password requested
                </Alert>
              </Collapse>
            </>
        );
      }
    },
    {
      title: 'Last Login',
      render: rowData => {
        let lastLogin = 'Never';
        const found = authData.length > 0 ? authData.find(authUser => authUser.email === rowData.email): null;
        if (found?.last_login) {
          let date = new Date(found.last_login);
          let dateToLocal = date.toLocaleDateString("en-US", {year: 'numeric', month: 'short', day: 'numeric' }).replace(',', '');
          let dateSplit = dateToLocal.split(' ');
          lastLogin = `${dateSplit[0]} ${dateSplit[1].padStart(2, '0')} ${dateSplit[2]}`;
        }
        return lastLogin;
      }
    },

    {
      title: 'Login Count',
      render: rowData => {
        const found = authData.length > 0 ? authData.find(authUser => authUser.email === rowData.email): null;
        return (<>{found ? found.logins_count ? found.logins_count : 0 : 0}</>);
      }
    },
    { title: 'Is sharing enabled?', field: 'enable_share', type: 'boolean' },
    { title: 'Created At', field: 'created_at', sorting: true, defaultSort: 'desc', editable: 'never', type: 'datetime',
      render: rowData => {
        let date = new Date(rowData.created_at);
        let dateToLocal = date.toLocaleDateString("en-US", {year: 'numeric', month: 'short', day: 'numeric' }).replace(',', '');
        let dateSplit = dateToLocal.split(' ');
        return `${dateSplit[0]} ${dateSplit[1].padStart(2, '0')} ${dateSplit[2]}`;
      }
    }
  ];

  if (user[`${process.env.REACT_APP_AUTH0_KEY}/role`] === 'api_group_admin') {
    columns = columns.filter(license => license.field !== 'enable_share');
  }

  axios.defaults.headers.common['Authorization'] = `Bearer ${getToken()}`;

  const getAuthToken = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/rpc/auth0-token`, {
      headers: {
        'ngrok-skip-browser-warning': true
      }
    })
      .then(res => {
        setAuthToken(res.data[0]);
      });
  }

  const addUserAuth = (id, newData) => {
    const token = authToken;

    axios.get(`${process.env.REACT_APP_API_URL}/rpc/create_user?_id=` + id, {
      headers: {
        'ngrok-skip-browser-warning': true
      }
    })
      .then(res => {
        let userData = res.data[0];
        userData['password'] = randomTempPassword(18);
        userData['connection'] = process.env.REACT_APP_AUTH0_CONNECTION;
        userData['verify_email'] = false;
        // session type null is a "No License" user.
        userData.app_metadata.district.sessionType = userData.app_metadata.district.sessionType || "No License"

        axios.post('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/api/v2/users', userData,
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          })
          .then(res => {
            delete newData.license_type;
            newData['user_id'] = res.data.user_id;
            newData['id'] = id;
            newData['group_id'] = parseInt(newData['group_id']);
            newData['is_created'] = true;

            axios.put(`${process.env.REACT_APP_API_URL}/users?id=eq.${id}`, newData,{
              headers: {
                'ngrok-skip-browser-warning': true
              }
            })
              .then(response => {
                let resetPassword = {
                  "client_id": process.env.REACT_APP_AUTH0_CLIENT_ID,
                  "email": newData.email,
                  "connection": process.env.REACT_APP_AUTH0_CONNECTION
                };

                axios.post('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/dbconnections/change_password', resetPassword,
                  {
                    headers: {
                      'Content-Type': 'application/json'
                    }
                  })
                  .then(res => {
                    getUsers();
                  });
                setIserror(false);
                setErrorMessages([]);
              })
              .catch(error => {
                if (error.response) {
                  // Request made and server responded
                  setErrorMessages([`Update failed! ${error.response.data.details}`]);
                }

                setIserror(true);
              });
          });
      })
  }

  const getUsers = useCallback(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/users?group_id=eq.${groupID}`, {
      headers: {
        'ngrok-skip-browser-warning': true
      }
    })
      .then((res) => {
        let userWithLicenseType = (res.data).map(function (obj) {
          obj['created_at'] =  new Date(obj['created_at']);
          if (obj.license_id) {
            return axios.get(`${process.env.REACT_APP_API_URL}/licenses?uuid=eq.${obj.license_id}`,
              {
                headers: {
                  'ngrok-skip-browser-warning': true  
                }
              })
              .then(function (results) {
                return obj = { ...obj, 'license_type': results.data[0].type }

              })
          } else {
            return obj = { ...obj, 'license_type': null }
          }
        })
        Promise.all(userWithLicenseType).then(function (results) {
          setUsersByGroup(results)
        })
      })
  }, [groupID]);

  const getLicenses = (id) => {
    simpleFetch(`${process.env.REACT_APP_API_URL}/rpc/pending_licenses?_groupid=${id}`)
      .then(response => {
        response.push({ value: 'No License', label: 'No License' });
        setLicensesByGroup(response)
      })

  }

  useEffect(() => {
    getAuthToken();
    getUsers();
    if (user[`${process.env.REACT_APP_AUTH0_KEY}/role`] === 'api_super_admin') {
      axios.get(`${process.env.REACT_APP_API_URL}/groups`, {
         headers: {
          'ngrok-skip-browser-warning': true
        }
      })
        .then(res => {
          const groups = res.data;
          setGroups(groups);
        })
    } else {
      axios.get(`${process.env.REACT_APP_API_URL}/users?email=eq.${encodeURIComponent(user.email)}`, {
        headers: {
          'ngrok-skip-browser-warning': true
        }
      })
        .then(res => {
          let userGroupId = res.data[0].group_id;
          axios.get(`${process.env.REACT_APP_API_URL}/groups?id=eq.${userGroupId}`, {
            headers: {
              'ngrok-skip-browser-warning': true
            }
          })
            .then(res => {
              const groups = res.data;
              setGroups(groups);
            })
        })
    }
  }, [user, getUsers]);

  useEffect(() => {
    if (groups.length > 0) {
      axios.get(`${process.env.REACT_APP_API_URL}/users?group_id=eq.${groupID}`, {
        headers: {
        'ngrok-skip-browser-warning': true
        }
      })
        .then((res) => {
          let userWithLicenseType = (res.data).map(function (obj) {
            obj["created_at"] = new Date(obj["created_at"]);
            if (obj.license_id) {
              return axios.get(`${process.env.REACT_APP_API_URL}/licenses?uuid=eq.${obj.license_id}`, {
                headers: {
                  'ngrok-skip-browser-warning': true
                }
              })
                .then(function (results) {
                  return obj = { ...obj, 'license_type': results.data[0].type }

                })
            } else {
              return obj = { ...obj, 'license_type': null }
            }
          })
          Promise.all(userWithLicenseType).then(function (results) {
            setUsersByGroup(results)
          })
        })
      getLicenses(groupID);
    }
    let buttons = document.querySelectorAll('.groups-buttons__item');
    buttons.forEach((button, key) => {
      if (key === 0) {
        button.classList.add('active')
      } else {
        button.classList.remove('active')
      }
    });
  }, [groups, groupID])


  //function for updating the existing row details
  const handleRowUpdate = (newData, oldData, resolve) => {
    // Validating license value.
    let newLicenseLabel = newData.license_id.label || oldData.license_type;
    newData.license_id = newData.license_id.value || newData.license_id

    // Cloning object and deleting the keys not required on data update.
    let dataToUpdate = structuredClone(newData);
    delete dataToUpdate.tableData;
    delete dataToUpdate.license_type;

    // Apply the .trim() method to the "name" value before updating the row data
    dataToUpdate.name = dataToUpdate.name.trim();
    // Email address syntax is not case sensitive so value is stored in lowercase.
    dataToUpdate.email = dataToUpdate.email.trim().toLowerCase();

    //validating the data inputs
    let errorList = []
    if (newData.email === "") {
      errorList.push("Oops!!! Please enter a valid email")
    }

    if (newData.license_id === 'No License') {
      dataToUpdate.license_id = null;
    }

    if (errorList.length < 1) {
      axios.put(`${process.env.REACT_APP_API_URL}/users?id=eq.${newData.id}`, dataToUpdate, {
        headers: {
        'ngrok-skip-browser-warning': true
        }
      })
        .then(response => {
          newData['connection'] = process.env.REACT_APP_AUTH0_CONNECTION;

          axios.get(`${process.env.REACT_APP_API_URL}/rpc/create_user?_id=` + newData.id,  {
            headers: {
            'ngrok-skip-browser-warning': true
            }
          })
            .then(res => {
              let userData = res.data[0]['app_metadata'];
              userData = { 'app_metadata': userData }
              userData.app_metadata.district.sessionType = newLicenseLabel;
              userData['email'] = newData['email'];

              axios.patch('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/api/v2/users/' + newData['user_id'], userData,
                {
                  headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                  }
                });
            });

          getLicenses(groupID);
          getUsers();
          resolve();
          setIserror(false);
          setErrorMessages([]);
        })
        .catch(error => {
          if (error.response) {
            // Request made and server responded
            setErrorMessages([`Update failed! ${error.response.data.details}`]);
          }

          setIserror(true);
          resolve();
        })
    } else {
      setErrorMessages(errorList);
      setIserror(true);
      resolve();
    }
  }

  //function for deleting a row
  const handleRowDelete = (oldData, resolve) => {
    axios.delete(`${process.env.REACT_APP_API_URL}/users?id=eq.${oldData.id}`, {
      headers: {
        'ngrok-skip-browser-warning': true
      }
    })
      .then(response => {
        axios.delete('https://' + process.env.REACT_APP_AUTH0_DOMAIN + '/api/v2/users/' + oldData['user_id'],
          {
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json'
            }
          });
        getLicenses(groupID);
        getUsers();
        resolve();
      })
      .catch(error => {
        if (error.response) {
          // Request made and server responded
          setErrorMessages([`Delete failed! ${error.response.data.details}`]);
        }

        setIserror(true);
        resolve();
      })
  }

  //function for adding a new row to the table
  const handleRowAdd = (newData, resolve) => {
    //validating the data inputs
    let errorList = []
    // Trim the input values
    newData.name = newData.name.trim();
    // Email address syntax is not case sensitive so value is stored in lowercase.
    newData.email = newData.email.trim().toLowerCase();
    
    // Sending only the value as id.
    newData.license_id = newData.license_id.value

    if (newData.email === "") {
      errorList.push("Oops!!! Please enter a valid email")
    }

    if (errorList.length < 1) {
      if (newData.license_id === 'No License') {
        newData.license_id = null;
      }

      if (user[`${process.env.REACT_APP_AUTH0_KEY}/role`] === 'api_group_admin') {
        newData.group_id = groupID;
        newData.role = 'api_user';
      }

      axios.post(`${process.env.REACT_APP_API_URL}/users`, newData,
        {
          headers: {
            'ngrok-skip-browser-warning': true,
            'Prefer': 'return=headers-only'
          }
        })
        .then(response => {
          let raw_id = response.headers['location'];
          let new_id = raw_id.replace('/users?id=eq.', '');

          addUserAuth(new_id, newData);
          getLicenses(groupID);
          getUsers();
          resolve();
          setErrorMessages([]);
          setIserror(false);
        })
        .catch(error => {
          if (error.response) {
            // Request made and server responded
            setErrorMessages([`Cannot add data. ${error.response.data.details}`]);
          }

          setIserror(true);
          resolve();
        })
    } else {
      setErrorMessages(errorList);
      setIserror(true);
      resolve();
    }
  }

  return (
    <div className={"users-by-account"} id={"usersByAccount"}>
      <div className="table-wrapper" style={{ padding: 20 }}>
        <div>
          {iserror &&
            <Alert severity="error">
              <AlertTitle>ERROR</AlertTitle>
              {errorMessages.map((msg, i) => {
                return <div key={i}>{msg}</div>
              })}
            </Alert>
          }
        </div>
        <MaterialTable
          title="Users"
          columns={columns}
          data={
            ["api_super_admin", "api_group_admin"].includes(userRole) ? usersByGroup : null
          }
          components = {{
            Toolbar: props => (
                <div style={{ position: "relative"}}>
                    <StyledTable
                    {...props} 
                    classes={{ root: "board-toolbar" }} 
                    />
                </div>
            ),
          }}
          icons={{
            Add: props => <Box component="span" className="table-button add-user" sx={AddButtonStyles}><AddIcon {...props} /> Add User</Box>,
            Edit: () => <EditIcon/>,
            Delete: () => <DeleteIcon/>,
          }}
          options={{
            headerStyle: { borderBottomColor: 'rgb(102, 16, 242)', borderBottomWidth: '3px' },
            actionsColumnIndex: -1,
            toolbarButtonAlignment: "left",
            pageSize: 20,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [10, 20, 30, 50]
          }}
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                handleRowUpdate(newData, oldData, resolve);
              }),
            onRowAdd: (newData) =>
              new Promise((resolve) => {
                handleRowAdd(newData, resolve)
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                handleRowDelete(oldData, resolve)
              }),
          }}
        />
      </div>
    </div>
  );
}

export default UsersByAccount;
